let eventSource = null;
let reconnectTimeout = null;
let reconnectDelay = 1000;  // Początkowy czas (1 sekunda)
const maxReconnectDelay = 30000;  // Maksymalny czas opóźnienia (30 sekund)
const listeners = [];

const connectToSSE = (url) => {
    if (eventSource) {
        eventSource.close();
    }
    
    console.log('Łączenie z SSE na adres: ' + url);
    eventSource = new EventSource(url);

    eventSource.onopen = () => {
        console.log('Połączono z SSE');
        reconnectDelay = 1000;  // Resetuj opóźnienie po udanym połączeniu
    };

    eventSource.onmessage = (event) => {
        console.log('Otrzymano wiadomość z SSE: '+ event.data);
        const data = JSON.parse(event.data);
        //alert(data.message);
        listeners.forEach(callback => callback(data));
    };

    eventSource.onerror = () => {
        console.error('Błąd połączenia SSE. Próbuję ponownie...');
        eventSource.close();
        scheduleReconnect(url);
    };

    eventSource.onclose = () => {
        console.log('Połączenie SSE zamknięte. Reconnecting...');
        scheduleReconnect(url);
    };
};

const scheduleReconnect = (url) => {
    console.log('Ponawianie połączenia SSE. Reconnecting...');
    if (reconnectTimeout) clearTimeout(reconnectTimeout);

    reconnectTimeout = setTimeout(() => {
        reconnectDelay = Math.min(reconnectDelay * 2, maxReconnectDelay);
        connectToSSE(url);
    }, reconnectDelay);
};

// Rejestracja callbacków na nowe wiadomości
const addEventListener = (callback) => {
  listeners.push(callback);
};

// Zamykanie połączenia
const closeConnection = () => {
  if (eventSource) {
    eventSource.close();
  }
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout);
  }
};

// Eksport funkcji
export { connectToSSE, addEventListener, closeConnection };
